import {
  MESSAGES_ADD_RESPONSE, MESSAGES_ARCHIVE, MESSAGES_ERROR, MESSAGES_LOADING,
  MESSAGES_UPDATE
} from "../actions/messagesActions";
import _ from 'lodash';
import {MESSAGE_DETAIL_MARK_AS_READ} from "../actions/messageDetailActions";

const INITIAL_STATE = {
  messages: [],
  messagesPagination: null,
  messagesLoading: false,
  messagesError: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MESSAGES_UPDATE:
      return {
        ...state,
        messages: action.payload.data,
        messagesPagination: action.payload.pagination,
        messagesError: action.payload.message,
      };
    case MESSAGES_ERROR:
      return {
        ...state,
        messagesError: action.payload,
      };
    case MESSAGES_LOADING:
      return {
        ...state,
        messagesLoading: action.payload,
      };
    case MESSAGES_ADD_RESPONSE:
      const messages = state.messages;
      messages.forEach((message) => {
          message.children.push(action.payload);
      });
      return {
        ...state,
        messages: messages,
      };
    case MESSAGES_ARCHIVE:
      const messagesToArchive = _.cloneDeep(state.messages);
      messagesToArchive.forEach((message) => {
        if (message.id.toString() === action.id.toString()){
          message.active = false;
          message.children.forEach((messageChildren) => {
            messageChildren.active = false;
          })
        }
      });
      return {
        ...state,
        messages: messagesToArchive,
      };
    case MESSAGE_DETAIL_MARK_AS_READ:
      const newMessages = state.messages.map((message) => {
        if (message.id.toString() === action.payload.toString()) {
          message.is_read = true;
        }
        return message;
      });
      return {
        ...state,
        messages: newMessages,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/to-refactor/shared/reducer/MessagesReducer.js